






















import {Vue, Component, Prop} from 'vue-property-decorator';

@Component({})
export default class NumberPad extends Vue {
 @Prop(Number) readonly value!:number
  output = this.value.toString()

  inputContent(event: MouseEvent){
    const button = (event.target as HTMLButtonElement)
    const input = button.textContent!
    if(this.output.length === 14){return}
    if(this.output === '0'){
      if ('1234567890'.indexOf(input) < 0) {
        this.output += input;
      }
      else {
        this.output = input;
      }
      return;
    }
    if(this.output.indexOf('.') >= 0 && input === '.'){
      return
    }
    this.output += input
  }

  remove(){
   this.output.length === 1 ?
     this.output = '0' :
     this.output = this.output.slice(0, -1)
    // this.output = this.output.substring(0, this.output.length-1)
  }
  clear(){
   this.output = '0'
  }
  ok(){
    this.output = this.output.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3")
   if(this.output === '0' || this.output === '0.0'  || this.output === '0.00' ){
     this.clear()
     window.alert('输入金额不能为0')
     return
   }
   const number = parseFloat(this.output)
    this.$emit('update:value',number)
    this.$emit('submit', number)
    // window.alert('您有一笔账单已记录在册')
    this.output = '0'
  }

}
